export const optionEntitiesSelector = state => state.options.entities;
